import React, { useEffect, useState } from "react";
import { Routes, Route, useParams, useNavigate } from "react-router-dom";
import LangSelect from "./Login/LangSelect";
import EnterNumber from "./Login/EnterNumber";
import Otp from "./Login/Otp";
import Home from "./Home/Home";
import SelectLocation from "./Map/SelectLocation";
import Card from "./Card/Card";
import Refer from "./Card/Refer";
import Canvas from "./Card/Canvas";
import {
  doRequest,
  parseURLParams,
  produrl,
  textMapping,
} from "./utils/helper";
import Loader from "./Popup/Loader";
import ReferList from "./Card/ReferList";
// import Screen from "./Card/Screen";
// import UserData from "./userdata";

const CryptoJS = require("crypto-js");

const AppRouter = () => {
  const navigate = useNavigate();
  const [showCustomPopup, setShowCustomPopup] = useState(false);
  const { refnum, lang } = useParams();
  const [loading, setLoading] = useState(false);
  const [langSelect, setLangSelect] = useState("en");
  const [staticnumber, setStaticnnumber] = useState("");
  const encryptData = (data, secretKey) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
  };

  // useEffect(() => {
  //   const handleUserInfo = async () => {
  //     const urlParams = parseURLParams(window.location.href);
  //     let user_id = "";

  //     try {
  //       let href = window.location.href;
  //       href = href.split("?userid=")[1];
  //       user_id = href.split("&")[0];
  //     } catch (error) {}

  //     const userid =
  //       urlParams && urlParams["userid"]
  //         ? urlParams["userid"][0]
  //         : user_id
  //         ? user_id
  //         : "";

  //     if (userid) {
  //       await getUserInfo(userid);
  //     }
  //   };

  //   handleUserInfo();
  // }, []);

  const getUserInfo = async (async) => {
    var urlParams = parseURLParams(window.location.href);
    let user_id = "";

    try {
      let href = window.location.href;
      href = href.split("?userid=")[1];
      user_id = href.split("&")[0];
    } catch (error) {}

    var userid =
      urlParams && urlParams["userid"]
        ? urlParams["userid"][0]
        : user_id
        ? user_id
        : "";

    var data = {
      action: "login-membership",
    };
    if (userid) {
      data["data"] = {
        userid: userid,
      };
    }
    var request = doRequest(data, async);
    request.addEventListener("load", function () {
      try {
        var data = JSON.parse(request.responseText);
        if (data["_resultflag"] && data["_resultflag"] === 1) {
          // localStorage.removeItem("user");

          let userData = JSON.stringify(data["user"]["data"]);
          localStorage.setItem("token", data["token"]);

          setStaticnnumber(JSON.parse(userData)["user_contact_no"]);

          let obj = {};

          obj["name"] = JSON.parse(userData)["user_name_display"]
            ? JSON.parse(userData)["user_name_display"]
            : "";
          obj["number"] = JSON.parse(userData)["user_contact_no"]
            ? JSON.parse(userData)["user_contact_no"]
            : "";
          obj["dob"] = JSON.parse(userData)["user_date_of_birth"]
            ? JSON.parse(userData)["user_date_of_birth"]
            : "";
          obj["useremail"] = JSON.parse(userData)["user_email"]
            ? JSON.parse(userData)["user_email"]
            : "";
          obj["statename"] = JSON.parse(userData)["state_name"]
            ? JSON.parse(userData)["state_name"]
            : "";
          obj["stateid"] = JSON.parse(userData)["state_id"]
            ? JSON.parse(userData)["state_id"]
            : "";
          obj["district_name"] = JSON.parse(userData)["district_name"]
            ? JSON.parse(userData)["district_name"]
            : "";
          obj["constituency_name"] = JSON.parse(userData)["constituency_name"]
            ? JSON.parse(userData)["constituency_name"]
            : "";
          obj["district_name"] = JSON.parse(userData)["district_name"]
            ? JSON.parse(userData)["district_name"]
            : "";
          obj["referral"] = JSON.parse(userData)["referral_code"]
            ? JSON.parse(userData)["referral_code"]
            : "";
          obj["gender"] = JSON.parse(userData)["user_gender"]
            ? JSON.parse(userData)["user_gender"]
            : "";
          obj["avatar"] = JSON.parse(userData)["user_avatar"]
            ? JSON.parse(userData)["user_avatar"]
            : "";

          const secretKey = "2ca6f23d8cc3e1e1";
          const encryptedData = encryptData(obj, secretKey);
          localStorage.setItem("user", encryptedData);
        }
      } catch (ex) {}
    });
  };

  useEffect(() => {
    var urlParams = parseURLParams(window.location.href);
    let user_id = "";

    try {
      let href = window.location.href;
      href = href.split("?userid=")[1];
      user_id = href.split("&")[0];
    } catch (error) {}

    var userid =
      urlParams && urlParams["userid"]
        ? urlParams["userid"][0]
        : user_id
        ? user_id
        : "";

    if (userid) {
      getUserInfo(true);
    }

    let token = localStorage.getItem("acesss");
    let refresh = localStorage.getItem("refresh");

    if (token && refresh) {
      setShowCustomPopup(true);
      console.log("exist");
      getRefreshToken();
    }
  }, []);

  const getFetchdetail = async () => {
    const url = `${produrl}api/v1/pm/details`;
    const options = {
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("acesss"),
      },
    };

    try {
      const response = await fetch(url, options);
      const data = await response.json();
      if (response.status === 200) {
        if (data.data.aasm_state == "complete") {
          setShowCustomPopup(false);
          if (refnum) {
            navigate("/refer/" + refnum + window.location.search);
          } else {
            navigate("/refer/" + window.location.search);
            setShowCustomPopup(false);
          }
        } else {
          setShowCustomPopup(false);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getRefreshToken = async () => {
    setLoading(true);
    const url = `${produrl}api/v1/token/refresh`;
    const formdata = new FormData();
    formdata.append("refresh_token", localStorage.getItem("refresh"));
    const options = {
      method: "POST",
      body: formdata,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("acesss"),
      },
    };

    try {
      const response = await fetch(url, options);
      const data = await response.json();
      if (response.status === 200) {
        console.log(data);
        localStorage.setItem("acesss", data.token.access_token);
        localStorage.setItem("refresh", data.token.refresh_token);
        setTimeout(() => {
          getFetchdetail();
        });
        setLoading(false);
      } else {
        setLoading(false);
        setShowCustomPopup(false);
        localStorage.clear();
        if (lang) {
          window.location = `/${lang}`;
        } else {
          window.location.reload();
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
  console.log("showCustomPopup", showCustomPopup);
  return (
    <>
      {loading && <Loader />}

      {showCustomPopup && (
        <div className="custom-popup-overlay">
          <div className="custom-popup">
            <div className="custom-loader"></div>
            <p>Loading...</p>
          </div>
        </div>
      )}
      {!showCustomPopup && (
        <Routes>
          <Route exact path="/otp/:refnum?" element={<Otp />} />
          <Route exact path="/home/:refnum?" element={<Home />} />
          <Route exact path="/refer/:refnum?" element={<Refer />} />
          {/* <Route exact path="/screen" element={<Screen />} /> */}
          <Route
            exact
            path="/reff/:refnum?"
            element={<EnterNumber staticnumber={staticnumber} />}
          />
          <Route exact path="/referlist/:refnum?" element={<ReferList />} />
          <Route
            exact
            path="/:lang?"
            element={<EnterNumber staticnumber={staticnumber} />}
          />
        </Routes>
      )}
    </>
  );
};

export default AppRouter;
